import React, { ReactElement } from 'react';
import { BillAction } from '@enview/interface/types/bills/Bill';
import { ActivityCard, ActivityCardStyle } from './ActivityCard';
import ActionCalendar from '../../../../components/svg/CalendarCircleIcon';
import './ActivityCard.scss';
import { formatDate } from '../../../../helpers/BillHelper';

type BillActionActivityCardProps = {
  billAction: BillAction;
};

const BillActivityCard = (props: BillActionActivityCardProps): ReactElement => {
  const { billAction } = props;

  const date = formatDate(billAction.actionDate);
  return (
    <ActivityCard
      activityStyle={ActivityCardStyle.BILL_ACTIVITY}
      icon={<ActionCalendar />}
      iconColor="orange"
      pretitle={date}
      title={<span>{billAction.description}</span>}
    />
  );
};

export default BillActivityCard;
